import { useEffect, useState } from "react";
import { UserPlus, Trash2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const ROLES = [
  { v: "super_admin", l: "সুপার অ্যাডমিন" },
  { v: "admin", l: "অ্যাডমিন" },
  { v: "editor", l: "এডিটর" },
  { v: "content_manager", l: "কনটেন্ট ম্যানেজার" },
];
const roleLabel = (v) => ROLES.find((r) => r.v === v)?.l || v;

export default function Users() {
  const { user } = useAuth();
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState({ email: "", password: "", name: "", role: "editor" });
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/admin/users").then((r) => setUsers(r.data)).catch(() => toast.error("অনুমতি নেই"));
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/admin/users", form);
      toast.success("ব্যবহারকারী যোগ হয়েছে");
      setForm({ email: "", password: "", name: "", role: "editor" });
      load();
    } catch (e2) {
      toast.error(formatApiErrorDetail(e2.response?.data?.detail));
    } finally { setBusy(false); }
  };

  const remove = async (id) => {
    if (!window.confirm("মুছে ফেলবেন?")) return;
    try { await api.delete(`/admin/users/${id}`); load(); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  };

  return (
    <div className="max-w-4xl">
      <h1 className="font-heading text-2xl font-bold text-stone-800 mb-1">ব্যবহারকারী ব্যবস্থাপনা</h1>
      <p className="text-sm text-stone-500 mb-6">রোল-ভিত্তিক অ্যাক্সেস সহ অ্যাডমিন অ্যাকাউন্ট</p>

      <form onSubmit={add} className="bg-white rounded-2xl border border-stone-200 p-6 grid sm:grid-cols-2 lg:grid-cols-5 gap-3 items-end mb-6">
        <div><label className="block text-xs text-stone-500 mb-1">নাম</label><input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full rounded-lg border border-stone-200 px-3 py-2 text-sm" /></div>
        <div><label className="block text-xs text-stone-500 mb-1">ইমেইল</label><input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full rounded-lg border border-stone-200 px-3 py-2 text-sm" /></div>
        <div><label className="block text-xs text-stone-500 mb-1">পাসওয়ার্ড</label><input required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="w-full rounded-lg border border-stone-200 px-3 py-2 text-sm" /></div>
        <div><label className="block text-xs text-stone-500 mb-1">রোল</label>
          <select value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} className="w-full rounded-lg border border-stone-200 px-3 py-2 text-sm">
            {ROLES.map((r) => <option key={r.v} value={r.v}>{r.l}</option>)}
          </select>
        </div>
        <button disabled={busy} className="inline-flex items-center justify-center gap-2 rounded-lg bg-[var(--c-primary)] text-white px-4 py-2 text-sm hover:bg-[var(--c-secondary)] transition-colors disabled:opacity-60">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <UserPlus className="h-4 w-4" />} যোগ করুন
        </button>
      </form>

      <div className="bg-white rounded-2xl border border-stone-200 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-stone-50 text-stone-500">
            <tr><th className="text-right p-4 font-medium">নাম</th><th className="text-right p-4 font-medium">ইমেইল</th><th className="text-right p-4 font-medium">রোল</th><th className="p-4"></th></tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id} className="border-t border-stone-100">
                <td className="p-4 text-stone-700">{u.name || "—"}</td>
                <td className="p-4 text-stone-600">{u.email}</td>
                <td className="p-4"><span className="rounded-full bg-stone-100 px-2.5 py-1 text-xs text-stone-600">{roleLabel(u.role)}</span></td>
                <td className="p-4">{u.role !== "super_admin" && u.email !== user?.email && <button onClick={() => remove(u.id)} className="text-red-400 hover:text-red-600"><Trash2 className="h-4 w-4" /></button>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
